import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from "@angular/material";
import { MatCardModule } from '@angular/material';
import { MatButtonModule } from '@angular/material';
import { MatDialogModule } from '@angular/material';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { SessionService } from "./shared/services/session.service";
import { ChaptersModule } from './chapters/chapters.module';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

//start
import { KeyboardToolComponent } from './shared/tools/keyboard-tool/keyboard-tool.component';
import { DrawingToolComponent } from './shared/tools/drawing-tool/drawing-tool.component';
import { ActivationComponent } from './chapters/activation/activation.component';
import { HomeComponent } from './home/home.component';
import { Yr3RbIndexComponent } from './yr3-rb/yr3-rb-index/yr3-rb-index.component';
import { Yr3WbIndexComponent } from './yr3-wb/yr3-wb-index/yr3-wb-index.component';
import { Yr3StorybookComponent } from './yr3-rb/yr3-storybook/yr3-storybook.component';
import { PdflistComponent } from './yr3-tilllararen/pdfprinting/pdflist/pdflist.component';
import { Printpdflist1Component } from './yr3-tilllararen/pdfprinting/printpdflist1/printpdflist1.component';
import { Printpdflist2Component } from './yr3-tilllararen/pdfprinting/printpdflist2/printpdflist2.component';
import { Printpdflist3Component } from './yr3-tilllararen/pdfprinting/printpdflist3/printpdflist3.component';
import { Printpdflist4Component } from './yr3-tilllararen/pdfprinting/printpdflist4/printpdflist4.component';
import { Printpdflist5Component } from './yr3-tilllararen/pdfprinting/printpdflist5/printpdflist5.component';
import { Printpdflist6Component } from './yr3-tilllararen/pdfprinting/printpdflist6/printpdflist6.component';
import { Printpdflist7Component } from './yr3-tilllararen/pdfprinting/printpdflist7/printpdflist7.component';
import { Printpdflist8Component } from './yr3-tilllararen/pdfprinting/printpdflist8/printpdflist8.component';
import { InloggningComponent } from './yr3-tilllararen/student/inloggning/inloggning.component';
import { BladderblocketComponent } from './yr3-tincan/bladderblocket/bladderblocket.component';
import { Yr3StStudenthomeComponent } from './yr3-studentweb/yr3-st-studenthome/yr3-st-studenthome.component';
import { Yr3StStorybookshelfComponent } from './yr3-studentweb/yr3-st-storybookshelf/yr3-st-storybookshelf.component';
import { Yr3StLevelbookshelfAComponent } from './yr3-studentweb/yr3-st-levelbookshelf-a/yr3-st-levelbookshelf-a.component';
import { Yr3StLevelbookshelfBComponent } from './yr3-studentweb/yr3-st-levelbookshelf-b/yr3-st-levelbookshelf-b.component';
import { Yr3StStavaChapter6Component } from './yr3-studentweb/yr3-st-stava/yr3-st-stava-chapter6/yr3-st-stava-chapter6.component';
import { Yr3StOrdattforstaChapter6Component } from './yr3-studentweb/yr3-st-ordattforsta/yr3-st-ordattforsta-chapter6/yr3-st-ordattforsta-chapter6.component';
import { Yr3StBladderblocketComponent } from './yr3-studentweb/yr3-st-bladderblocket/yr3-st-bladderblocket.component';
import { Yr3StMemorygameComponent } from './yr3-studentweb/yr3-st-memorygame/yr3-st-memorygame.component';
import { StoryassigningpageComponent } from './yr3-tilllararen/storyassigningpage/storyassigningpage.component';

//Wb-page popups start

import { Yr3WbPopupPg52Component } from './yr3-wb/yr3-wb-popup/yr3-wb-popup-pg52/yr3-wb-popup-pg52.component';
import { ExCh06Page1Component } from './yr3-rb/yr3-page1-exercise/ex-ch06-page1/ex-ch06-page1.component';
import { Yr3StStorybookComponent } from './yr3-studentweb/yr3-st-storybook/yr3-st-storybook.component';
import { BorjorComponent } from './yr3-tincan/borjor/borjor.component';
import { AlfabetetAaComponent } from './yr3-tincan/alfabetstavlor/alfabetet-aa/alfabetet-aa.component';

const routes: Routes = [

  { path: '', component: HomeComponent },
  { path: 'yr3-storybook/:id', component: Yr3StorybookComponent },
  { path: 'yr3-st-storybook/:id', component: Yr3StStorybookComponent },
  { path: 'yr3-rb-index', component: Yr3RbIndexComponent },
  { path: 'yr3-wb-index', component: Yr3WbIndexComponent },
  { path: 'home', component: HomeComponent },
  { path: 'pdfprinting/pdflist', component: PdflistComponent },
  { path: 'pdfprinting/printpdflist1', component: Printpdflist1Component },
  { path: 'pdfprinting/printpdflist2', component: Printpdflist2Component },
  { path: 'pdfprinting/printpdflist3', component: Printpdflist3Component },
  { path: 'pdfprinting/printpdflist4', component: Printpdflist4Component },
  { path: 'pdfprinting/printpdflist5', component: Printpdflist5Component },
  { path: 'pdfprinting/printpdflist6', component: Printpdflist6Component },
  { path: 'pdfprinting/printpdflist7', component: Printpdflist7Component },
  { path: 'pdfprinting/printpdflist8', component: Printpdflist8Component },
  { path: 'inloggning', component: InloggningComponent },
  { path: 'storyassigningpage', component: StoryassigningpageComponent },

  {
    path: 'chapter',
    children: [
      { path: 'activation', component: ActivationComponent }
    ]
  },

  { path: 'yr3-st-studenthome', component: Yr3StStudenthomeComponent },
  { path: 'yr3-st-storybookshelf', component: Yr3StStorybookshelfComponent },
  { path: 'yr3-st-levelbookshelf-a', component: Yr3StLevelbookshelfAComponent },
  { path: 'yr3-st-levelbookshelf-b', component: Yr3StLevelbookshelfBComponent },
 
  {
    path: 'rbpagech06', loadChildren: './yr3-rb/yr3-rb-pgs/yr3-rb-pgs-ch06/yr3-rb-pgs-ch06.module#yr3rbpgch06Module', data: { preload: true }
  },
  
  {
    path: 'wbpagech06', loadChildren: './yr3-wb/yr3-wb-pgs/yr3-wb-pgs-ch06/yr3-wb-pgs-ch06.module#yr3wbpgsch06Module', data: { preload: true }
  },
  
  {
    path: 'kapitelpdf', loadChildren: './yr3-rb/yr3-rb-kapitelpdf/yr3-rb-kapitelpdf.module#yr3rbkapitelpdfModule', data: { preload: true }
  },
  
  { path: 'yr3stdlevelbook', loadChildren: './yr3-studentweb/yr3-st-levelbook/yr3-st-levelbook.module#YR3stlevelbookModule', data: { preload: true } }

]


@NgModule({
  declarations: [
    KeyboardToolComponent,
    DrawingToolComponent,
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    Yr3StorybookComponent,
    Yr3StStorybookComponent,
    Yr3RbIndexComponent,
    PdflistComponent,
    Printpdflist1Component,
    Printpdflist2Component,
    Printpdflist3Component,
    Printpdflist4Component,
    Printpdflist5Component,
    Printpdflist6Component,
    Printpdflist7Component,
    Printpdflist8Component,
    BladderblocketComponent,
    InloggningComponent,    
    BorjorComponent,    
    AlfabetetAaComponent,  
    Yr3StStudenthomeComponent,
    Yr3StStorybookshelfComponent,
    Yr3StLevelbookshelfAComponent,
    Yr3StLevelbookshelfBComponent,   
    Yr3StStavaChapter6Component,   
    Yr3StOrdattforstaChapter6Component,   
    Yr3StBladderblocketComponent,  
    Yr3StMemorygameComponent,       
    Yr3WbIndexComponent,   
    ExCh06Page1Component,   
    Yr3WbPopupPg52Component,
    StoryassigningpageComponent,

  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    SharedModule,
    HttpModule,
    RouterModule.forRoot(routes),
    MatSnackBarModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule,
    ChaptersModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    FormsModule,
    NoopAnimationsModule

    
  ],
  entryComponents:
    [
      KeyboardToolComponent,
      DrawingToolComponent,     
      BorjorComponent,    
      AlfabetetAaComponent,   
      Yr3StStavaChapter6Component,   
      BladderblocketComponent,    
      Yr3StOrdattforstaChapter6Component,     
      Yr3StBladderblocketComponent,      
      Yr3StMemorygameComponent,        
      ExCh06Page1Component,    
      Yr3WbPopupPg52Component,
      StoryassigningpageComponent,

    ],
  providers: [
    SessionService,
    CookieService,
  ],
      bootstrap: [AppComponent]
})
export class AppModule { }
